import {
  init,
  track as plausibleTrack,
} from "@plausible-analytics/tracker";
import type { PlausibleEventOptions } from "@plausible-analytics/tracker";

let plausibleEnabled = false;

function parseTruthyEnv(value: string | undefined): boolean {
  const v = (value || "").trim().toLowerCase();
  return v === "true" || v === "1" || v === "yes";
}

/**
 * Initializes Plausible when VUE_APP_PLAUSIBLE_DOMAIN is set.
 * Default autoCapturePageviews handles Vue Router history SPAs.
 */
export function initPlausibleFromEnv(): void {
  const domain = (process.env.VUE_APP_PLAUSIBLE_DOMAIN || "").trim();
  if (!domain) {
    return;
  }

  const endpoint = (process.env.VUE_APP_PLAUSIBLE_ENDPOINT || "").trim();
  const captureOnLocalhost = parseTruthyEnv(
    process.env.VUE_APP_PLAUSIBLE_CAPTURE_LOCALHOST
  );

  init({
    domain,
    ...(endpoint ? { endpoint } : {}),
    hashBasedRouting: false,
    captureOnLocalhost,
    logging: process.env.NODE_ENV !== "production",
  });

  plausibleEnabled = true;

  if (process.env.NODE_ENV !== "production") {
    console.info("[Plausible] initialized", {
      domain,
      captureOnLocalhost,
      endpoint: endpoint || "(default https://plausible.io/api/event)",
    });
  }
}

/** Custom goals; no-ops when Plausible was not initialized. */
export function trackPlausibleEvent(
  eventName: string,
  options?: PlausibleEventOptions
): void {
  if (!plausibleEnabled) {
    return;
  }
  plausibleTrack(eventName, options ?? {});
}
